import { render } from "./CheckLanguage.vue?vue&type=template&id=203247df&scoped=true"
import script from "./CheckLanguage.vue?vue&type=script&lang=js"
export * from "./CheckLanguage.vue?vue&type=script&lang=js"

import "./CheckLanguage.vue?vue&type=style&index=0&id=203247df&scoped=true&lang=css"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203247df"]])

export default __exports__